import { useNavigate } from 'react-router-dom';

export const useNavigateToEdit = (id: number): (() => void) => {
  const navigate = useNavigate();
  return () => {
    navigate(`../edit/${id}`);
  };
};
